<template>
  <div data-grm-comp="RoomTestbankExamTable">
    <div class="h-full flex flex-col hidden lg:flex">
      <table class="test-bank-table">
        <colgroup>
          <col width="3%">
          <col width="12%">
          <col width="4%">
          <col width="12%">
          <col width="6%">
        </colgroup>
        <thead class="h-8 bg-gray-200">
          <tr>
            <th>{{ $t("common.number") }}</th>
            <th>{{ $t("setting.name.title") }}</th>
            <th>{{ $t("testBank.number.question") }}</th>
            <th>{{ $t("link.regDate") }}</th>
            <th></th>
          </tr>
        </thead>
      </table>
      <div class="max-h-full overflow-y-auto scrollbar-hide">
        <table class="test-bank-table">
          <colgroup>
            <col width="3%">
            <col width="12%">
            <col width="4%">
            <col width="12%">
            <col width="6%">
          </colgroup>
          <tbody>
            <template>
              <tr v-for="(exam, i) in testbankExamList?.content"
                  :key="exam.bankExamId"
                  class="cursor-pointer transition hover:bg-gray-100"
                  @click="onSelectExam(exam)"
              >
                <td>{{ testbankExamNum(i) }}</td>
                <td>{{ exam.examTitle }}</td>
                <td>{{ exam.questionCnt }}</td>
                <td>{{ exam.regDate }}</td>
                <td>
                  <div class="flex justify-center gap-x-1">
                    <GrmBtn size="xs" color="yellow" @click.stop="onCopyExam(exam)">{{ $t("common.copy") }}</GrmBtn>
                    <GrmBtn size="xs"  @click.stop="onEditExam(exam)">{{ $t("common.edit") }}</GrmBtn>
                    <GrmBtn size="xs" color="red" @click.stop="onDeleteExam(exam)">{{ $t("common.delete") }}</GrmBtn>
                  </div>
                </td>
              </tr>
              <tr v-if="!testbankExamList?.content?.length">
                <td colspan="5" class="text-center">{{ $t("testBank.alert.paper") }}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
    <div class="flex flex-col gap-2 lg:hidden">
      <div v-for="(exam, i) in testbankExamList?.content"
           :key="exam.bankExamId"
           class="p-2 rounded bg-gray-100"
      >
        <div class="flex">
          <div class="w-28 py-2 px-3 text-sm">{{ $t("common.number") }}</div>
          <div class="min-w-0 flex-1 py-2 px-3 text-sm">{{ i + 1 }}</div>
        </div>
        <div class="flex">
          <div class="w-28 py-2 px-3 text-sm">{{ $t("setting.name.title") }}</div>
          <div class="min-w-0 flex-1 py-2 px-3 text-sm">{{ exam.examTitle }}</div>
        </div>
        <div class="flex">
          <div class="w-28 py-2 px-3 text-sm">{{ $t("testBank.number.question") }}</div>
          <div class="min-w-0 flex-1 py-2 px-3 text-sm">{{ exam.questionCnt }}</div>
        </div>
        <div class="flex">
          <div class="w-28 py-2 px-3 text-sm">{{ $t("link.regDate") }}</div>
          <div class="min-w-0 flex-1 py-2 px-3 text-sm">{{ exam.regDate }}</div>
        </div>
        <div class="w-full flex gap-x-1">
          <GrmBtn class="flex-1" size="sm" @click="onSelectExam(exam)">{{ $t("setting.disclosure.password.see") }}</GrmBtn>
          <GrmBtn class="flex-1" size="sm" color="yellow" @click="onCopyExam(exam)">{{ $t("common.copy") }}</GrmBtn>
          <GrmBtn class="flex-1" size="sm" @click="onEditExam(exam)">{{ $t("common.edit") }}</GrmBtn>
          <GrmBtn class="flex-1" size="sm" color="red" @click="onDeleteExam(exam)">{{ $t("common.delete") }}</GrmBtn>
        </div>
      </div>
    </div>
    <div v-if="!testbankExamList?.content?.length" class="lg:hidden">
        <p class="text-center p-2 rounded bg-gray-100 text-sm">{{ $t("testBank.alert.paper") }}</p>
    </div>
    <GrmPagination class="mt-3"
                   :pageInfo="testbankExamList?.pageInfo"
                   @paging="(page) => { getTestbankExamList({ page }) }"
    />
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";

import GrmBtn from "@/components/Common/button/GrmBtn.vue";
import GrmPagination from "@/components/Common/pagination/GrmPagination.vue";
import Testbank from "@/components/Room/Testbank/Testbank.vue";

export default {
  name: 'RoomTestbankExamTable',
  components: {
    GrmBtn,
    GrmPagination,
  },
  data() {
    return {
      currentPage: 1,
    }
  },
  computed: {
    ...mapState('testbank', [
      'testbankExamList',
      'testbankExamListFilter',
    ]),
    testbankExamNum() {
      return (i) => {
        return this.testbankExamList.pageInfo.totalCount - ((this.testbankExamList.pageInfo.currentPageNum - 1) * this.testbankExamListFilter.size + i);
      }
    },
  },
  created() {
    this.getTestbankExamList();
  },
  methods: {
    ...mapMutations('testbank', [
      'SET_VIEW',
      'SET_TESTBANK_EXAM',
    ]),
    ...mapActions('testbank', [
      'getTestbankExam',
      'deleteTestbankExam',
      'getTestbankExamList',
    ]),

    onEditExam(exam) {
      this.SET_TESTBANK_EXAM(exam);
      this.SET_VIEW('testbank__exam_edit');
    },
    onCopyExam(exam) {
      this.SET_TESTBANK_EXAM(exam);
      this.SET_VIEW('testbank__exam_copy');
    },
    onDeleteExam(exam) {
      this.$alert({
        text: this.$t("testBank.alert.delete"),
        ok: () => {
          this.deleteTestbankExam({ bankExamId: exam.bankExamId });
        }
      })
    },
    onSelectExam(exam) {
      this.SET_TESTBANK_EXAM(exam);
      this.SET_VIEW('testbank__exam');
    },
  }
}
</script>

<style lang="scss" scoped>
.test-bank-table {
  width: 100%;
  font-size: 13px;
  text-align: center;
  table-layout: fixed;
}
tr {
  @apply h-10 border-b border-gray-100;
}
th {
  @apply px-3 text-xs
}
td {
  @apply px-3 text-xs truncate
}
</style>